exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ep-auth-page[data-v-4ab8cb56]{text-align:center;margin-top:15%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;row-gap:25px}.content-body[data-v-4ab8cb56]{font-size:1.5rem}.auth-result image[data-v-4ab8cb56]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ab8cb56","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/control/auth-result.vue
// module id = 927
// module chunks = 0